import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=4b6485e5&"
import script from "./DeliveryNote.vue?vue&type=script&lang=js&"
export * from "./DeliveryNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryNote.vue"
export default component.exports